import React from 'react'
import Slider from "react-slick";

function HeroSlider() {
    const settings = {
        dots: true,
        infinite: true,
        arrows: false,  // <-- fixed
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
        vertical: true,
        autoplay: true,
        speed: 3000,
        autoplaySpeed: 2000,
        verticalSwiping: true,
        beforeChange: (current, next) => console.log("before", current, next),
        afterChange: (current) => console.log("after", current),
    };

    return (
        <>
            <div className="slider-container custom-slider">
                <Slider {...settings}>
                    <div>
                        <div className="relative w-full h-auto overflow-hidden">
                            <video
                                className="absolute inset-0 w-full h-full object-cover"
                                src="/assets/value/power.mp4"
                                autoPlay
                                loop
                                muted
                                playsInline
                            ></video>
                            <div className="absolute inset-0 bg-black/50"></div>
                            <div className="relative pt-[130px] pb-[120px] sm:pt-[150px] sm:pb-[180px] md:pt-[200px] md:pb-[240px] lg:pt-[266px] lg:pb-[302px] flex flex-col items-center text-center z-10">
                                <h1 className="max-w-[1065px] w-full mx-auto font-kanit font-[500] lg:text-[72px] text-[40px] lg:leading-[106px] leading-[50px] text-center text-[#FFFFFF] pb-[33px]">
                                    Where Innovation Meets Technical Trust
                                </h1>
                                <button
                                    onClick={() => (window.location.href = "mailto:info@saig.me")}
                                    className="flex items-center justify-center gap-[12px] font-kanit font-[400] text-[17px] leading-[26px] text-[#FFFFFF] py-[14px] px-[20px] border border-[#FFFFFF] bg-transparent hover:bg-[#000000] transition-all duration-300 rounded-full group"
                                >
                                    Request a Quote
                                    <img
                                        src="/assets/nav/arrow.svg"
                                        alt="Trusted cable management and termination solutions provider in the UAE"
                                        className="transition-transform duration-300 group-hover:rotate-[42deg] group-hover:scale-150 rotate-[0deg]"
                                    />
                                </button>
                            </div>

                        </div>
                    </div>
                      <div>
                        <div className="relative w-full h-auto overflow-hidden">
                            <video
                                className="absolute inset-0 w-full h-full object-cover"
                                src="/assets/value/newv.mp4"
                                autoPlay
                                loop
                                muted
                                playsInline
                            ></video>
                            <div className="absolute inset-0 bg-black/50"></div>
                            <div className="relative pt-[130px] pb-[120px] sm:pt-[150px] sm:pb-[180px] md:pt-[200px] md:pb-[240px] lg:pt-[266px] lg:pb-[302px] flex flex-col items-center text-center z-10">
                                <h1 className="max-w-[1065px] w-full mx-auto font-kanit font-[500] lg:text-[72px] text-[40px] lg:leading-[106px] leading-[50px] text-center text-[#FFFFFF] pb-[33px]">
                                    Your One Stop Technical Partner in Cable Termination Solutions
                                </h1>
                                <button
                                    onClick={() => (window.location.href = "mailto:info@saig.me")}
                                    className="flex items-center justify-center gap-[12px] font-kanit font-[400] text-[17px] leading-[26px] text-[#FFFFFF] py-[14px] px-[20px] border border-[#FFFFFF] bg-transparent hover:bg-[#000000] transition-all duration-300 rounded-full group"
                                >
                                    Request a Quote
                                    <img
                                        src="/assets/nav/arrow.svg"
                                        alt="Trusted cable management and termination solutions provider in the UAE"
                                        className="transition-transform duration-300 group-hover:rotate-[42deg] group-hover:scale-150 rotate-[0deg]"
                                    />
                                </button>
                            </div>

                        </div>
                    </div>
                      <div>
                        <div className="relative w-full h-auto overflow-hidden">
                            <video
                                className="absolute inset-0 w-full h-full object-cover"
                                src="/assets/value/newvideo.mp4"
                                autoPlay
                                loop
                                muted
                                playsInline
                            ></video>
                            <div className="absolute inset-0 bg-black/50"></div>
                            <div className="relative pt-[130px] pb-[120px] sm:pt-[150px] sm:pb-[180px] md:pt-[200px] md:pb-[240px] lg:pt-[266px] lg:pb-[302px] flex flex-col items-center text-center z-10">
                                <h1 className="max-w-[1065px] w-full mx-auto font-kanit font-[500] lg:text-[72px] text-[40px] lg:leading-[106px] leading-[50px] text-center text-[#FFFFFF] pb-[33px]">
                                    Smart Cable Management Solutions You Can Trust
                                </h1>
                                <button
                                    onClick={() => (window.location.href = "mailto:info@saig.me")}
                                    className="flex items-center justify-center gap-[12px] font-kanit font-[400] text-[17px] leading-[26px] text-[#FFFFFF] py-[14px] px-[20px] border border-[#FFFFFF] bg-transparent hover:bg-[#000000] transition-all duration-300 rounded-full group"
                                >
                                    Request a Quote
                                    <img
                                        src="/assets/nav/arrow.svg"
                                        alt="Trusted cable management and termination solutions provider in the UAE"
                                        className="transition-transform duration-300 group-hover:rotate-[42deg] group-hover:scale-150 rotate-[0deg]"
                                    />
                                </button>
                            </div>

                        </div>
                    </div>
                      <div>
                        <div className="relative w-full h-auto overflow-hidden">
                            <video
                                className="absolute inset-0 w-full h-full object-cover"
                                src="/assets/value/video4.mp4"
                                autoPlay
                                loop
                                muted
                                playsInline
                            ></video>
                            <div className="absolute inset-0 bg-black/50"></div>
                            <div className="relative pt-[130px] pb-[120px] sm:pt-[150px] sm:pb-[180px] md:pt-[200px] md:pb-[240px] lg:pt-[266px] lg:pb-[302px] flex flex-col items-center text-center z-10">
                                <h1 className="max-w-[1065px] w-full mx-auto font-kanit font-[500] lg:text-[72px] text-[40px] lg:leading-[106px] leading-[50px] text-center text-[#FFFFFF] pb-[33px]">
                                    Reliable Electrical & Instrumentation Solutions
                                </h1>
                                <button
                                    onClick={() => (window.location.href = "mailto:info@saig.me")}
                                    className="flex items-center justify-center gap-[12px] font-kanit font-[400] text-[17px] leading-[26px] text-[#FFFFFF] py-[14px] px-[20px] border border-[#FFFFFF] bg-transparent hover:bg-[#000000] transition-all duration-300 rounded-full group"
                                >
                                    Request a Quote
                                    <img
                                        src="/assets/nav/arrow.svg"
                                        alt="Trusted cable management and termination solutions provider in the UAE"
                                        className="transition-transform duration-300 group-hover:rotate-[42deg] group-hover:scale-150 rotate-[0deg]"
                                    />
                                </button>
                            </div>

                        </div>
                    </div>
                    {/* <div>
                        <div
                            className="relative w-full h-auto bg-cover bg-center overflow-hidden"
                            style={{
                                backgroundImage: "url('/assets/value/bg1.jpg')",
                            }}
                        >
                            <div className="absolute inset-0 bg-black/50"></div>
                            <div className="relative pt-[100px] pb-[120px] sm:pt-[150px] sm:pb-[180px] md:pt-[200px] md:pb-[240px] lg:pt-[266px] lg:pb-[302px] flex flex-col items-center text-center z-10">
                                <h1 className="max-w-[1065px] w-full mx-auto font-kanit font-[500] lg:text-[72px] text-[40px] lg:leading-[106px] leading-[50px] text-center text-[#FFFFFF] pb-[33px]">
                                    Your One Stop Technical Partner in Cable Termination Solutions
                                </h1>
                                <button
                                    onClick={() => (window.location.href = "mailto:info@saig.me")}
                                    className="flex items-center justify-center gap-[12px] font-kanit font-[400] text-[17px] leading-[26px] text-[#FFFFFF] py-[14px] px-[20px] border border-[#FFFFFF] rounded-full bg-transparent hover:bg-[#000000] group transition-all duration-300"
                                >
                                    Request a Quote
                                    <img
                                        src="/assets/nav/arrow.svg"
                                        alt="Trusted cable management and termination solutions provider in the UAE"
                                        className="transition-transform duration-300 group-hover:rotate-[42deg] group-hover:scale-150 rotate-[0deg]"
                                    />
                                </button>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div
                            className="relative w-full h-auto bg-cover bg-center overflow-hidden"
                            style={{
                                backgroundImage: "url('/assets/value/bg2.jpeg')",
                            }}
                        >
                            <div className="absolute inset-0 bg-black/50"></div>
                            <div className="relative pt-[100px] pb-[120px] sm:pt-[150px] sm:pb-[180px] md:pt-[200px] md:pb-[240px] lg:pt-[266px] lg:pb-[302px] flex flex-col items-center text-center z-10">
                                <h1 className="max-w-[1065px] w-full mx-auto font-kanit font-[500] lg:text-[72px] text-[40px] lg:leading-[106px] leading-[50px] text-center text-[#FFFFFF] pb-[33px]">
                                    Smart Cable Management Solutions You Can Trust
                                </h1>
                                <button
                                    onClick={() => (window.location.href = "mailto:info@saig.me")}
                                    className="flex items-center justify-center gap-[12px] font-kanit font-[400] text-[17px] leading-[26px] text-[#FFFFFF] py-[14px] px-[20px] border border-[#FFFFFF] rounded-full bg-transparent hover:bg-[#000000] group transition-all duration-300"
                                >
                                    Request a Quote
                                    <img
                                        src="/assets/nav/arrow.svg"
                                        alt="Trusted cable management and termination solutions provider in the UAE"
                                        className="transition-transform duration-300 group-hover:rotate-[42deg] group-hover:scale-150 rotate-[0deg]"
                                    />
                                </button>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div
                            className="relative w-full h-auto bg-cover bg-center overflow-hidden"
                            style={{
                                backgroundImage: "url('/assets/value/bg3.jpeg')",
                            }}
                        >
                            <div className="absolute inset-0 bg-black/50"></div>
                            <div className="relative pt-[100px] pb-[120px] sm:pt-[150px] sm:pb-[180px] md:pt-[200px] md:pb-[240px] lg:pt-[266px] lg:pb-[302px] flex flex-col items-center text-center z-10">
                                <h1 className="max-w-[1065px] w-full mx-auto font-kanit font-[500] lg:text-[72px] text-[40px] lg:leading-[106px] leading-[50px] text-center text-[#FFFFFF] pb-[33px]">
                                    Engineering Reliable – Electrical & Instrumentation Bulk Solutions
                                </h1>
                                <button
                                    onClick={() => (window.location.href = "mailto:info@saig.me")}
                                    className="flex items-center justify-center gap-[12px] font-kanit font-[400] text-[17px] leading-[26px] text-[#FFFFFF] py-[14px] px-[20px] border border-[#FFFFFF] rounded-full bg-transparent hover:bg-[#000000] group transition-all duration-300"
                                >
                                    Request a Quote
                                    <img
                                        src="/assets/nav/arrow.svg"
                                        alt="Trusted cable management and termination solutions provider in the UAE"
                                        className="transition-transform duration-300 group-hover:rotate-[42deg] group-hover:scale-150 rotate-[0deg]"
                                    />
                                </button>
                            </div>
                        </div>
                    </div> */}
                    {/* 
                    <div className="hero-bg">
                        <div className="wrap1"></div>
                        <div className="pt-[100px] pb-[120px] sm:pt-[150px] sm:pb-[180px] md:pt-[200px] md:pb-[240px] lg:pt-[266px] lg:pb-[302px] flex flex-col items-center text-center">
                            <h1 className="max-w-[1065px] w-full mx-auto font-kanit font-[500] lg:text-[72px] text-[40px] lg:leading-[106px] leading-[50px] text-center text-[#FFFFFF] pb-[33px]"> Smart Cable Management Solutions You Can Trust</h1>
                            <button onClick={() => window.location.href = "mailto:info@saig.me"}
                                className="flex items-center justify-center gap-[12px] font-kanit font-[400] text-[17px] leading-[26px] text-[#FFFFFF] py-[14px] px-[20px] border border-[#FFFFFF] rounded-full bg-transparent hover:bg-[#000000] group transition-all duration-300">
                                Request a Quote
                                <img
                                    src="/assets/nav/arrow.svg"
                                    alt="	Trusted cable management and termination solutions provider in the UAE"
                                    className="transition-transform duration-300 group-hover:rotate-[42deg] group-hover:scale-150 rotate-[0deg]"
                                />
                            </button>
                        </div>
                    </div>
                    <div className="hero-bg">
                        <div className="wrap1"></div>
                        <div className="pt-[100px] pb-[120px] sm:pt-[150px] sm:pb-[180px] md:pt-[200px] md:pb-[240px] lg:pt-[266px] lg:pb-[302px] flex flex-col items-center text-center">

                            <h1 className="max-w-[1065px] w-full mx-auto font-kanit font-[500] lg:text-[72px] text-[40px] lg:leading-[106px] leading-[50px] text-center text-[#FFFFFF] pb-[33px]">Engineering Reliable – Electrical & Instrumentation Bulk Solutions</h1>
                            <button onClick={() => window.location.href = "mailto:info@saig.me"}
                                className="flex items-center justify-center gap-[12px] font-kanit font-[400] text-[17px] leading-[26px] text-[#FFFFFF] py-[14px] px-[20px] border border-[#FFFFFF] rounded-full bg-transparent hover:bg-[#000000] group transition-all duration-300">
                                Request a Quote
                                <img
                                    src="/assets/nav/arrow.svg"
                                    alt="	Trusted cable management and termination solutions provider in the UAE"
                                    className="transition-transform duration-300 group-hover:rotate-[42deg] group-hover:scale-150 rotate-[0deg]"
                                />
                            </button>
                        </div>
                    </div> */}
                </Slider>
            </div>
        </>
    )
}


export default HeroSlider
